import { useMemo, useState } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import useCampaigns from '@/hooks/useCampaigns';
import { ICampaign, IContact } from '@/types';
import axiosClient from '@/utils/axiosClient';
import DataTable from '../DataTable/DataTable';
import { Switch } from '../ui/switch';

interface CampaignAssociationsProps {
  contact: IContact;
}

const CampaignAssociations = ({ contact }: CampaignAssociationsProps) => {
  const campaigns = useCampaigns();
  const data = useMemo(() => campaigns.data || [], [campaigns.data]);
  const [list, setList] = useState<ICampaign[]>(contact.campaigns || []);

  async function toggle(campaign: ICampaign) {
    try {
      const response = await axiosClient.post(`v1/campaigns/${campaign.id}/toggle_contact`, {
        contact_id: contact.id,
      });
      if (response.status === 200) {
        setList((prev) => {
          const isInList = prev.some((item) => item.id === campaign.id);
          if (isInList) {
            return prev.filter((item) => item.id !== campaign.id);
          }
          return [...prev, campaign];
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const columns: ColumnDef<ICampaign>[] = [
    {
      accessorKey: 'name',
      header: 'Campaign',
    },
    {
      accessorKey: 'description',
      header: '',
    },
    {
      id: 'subscribed',
      header: 'Subscribed',
      cell: ({ row }) => (
        <Switch
          checked={list.some((item) => item.id === row.original.id)}
          onCheckedChange={() => {
            toggle(row.original as ICampaign);
          }}
        />
      ),
    },
  ];

  return <DataTable data={data} columns={columns} model={campaigns} placeholder="Search for campaigns..." />;
};

export default CampaignAssociations;
